import React, { useState } from 'react';
import { BaseModal, Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

type Props = {
  show: boolean;
  onClose: () => void;
};

type ResetPasswordFormType = {
  oldPassword?: string;
  newPassword?: string;
  confirmPassword?: string;
};
const ResetPasswordModal = ({ show, onClose }: Props) => {
  const defaultError = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  const [form, setForm] = useState<ResetPasswordFormType>({});
  const [errors, setErrors] = useState(defaultError);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleUpdate = async () => {
    const data = {
      old_assword: form.oldPassword,
      new_password: form.newPassword
    };
    try {
      setLoading(true);
      const res = await apiService.put(`user/change-password`, {
        data
      });
      if (res) {
        toast(<ToastMessage type='success' message='Password reset successfully' />);
        onClose();
        localStorage.clear();
        navigate('/');
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  const updatePassword = (val: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = val.target;

    setForm({ ...form, [name]: value });
  };
  return (
    <BaseModal
      isOpen={show}
      title='Reset Password'
      description={``}
      titleIconColor='danger'
      onRequestClose={() => onClose()}
      footer={
        <div className='flex justify-end gap-3'>
          <Button className='text-xs w-fit' color='primary' variant='outline' onClick={onClose}>
            Cancel
          </Button>
          <Button
            className='text-xs w-fit'
            color='primary'
            loading={loading}
            variant='block'
            onClick={handleUpdate}
            disabled={
              form.newPassword !== form.confirmPassword ||
              !form.oldPassword ||
              !form.newPassword ||
              !form.confirmPassword
            }>
            Confirm
          </Button>
        </div>
      }>
      <div className='flex flex-col gap-6 justify-center items-center'>
        <Input
          type='password'
          className='w-full'
          design='bordered'
          label={'Old Password'}
          placeholder={'Enter old password'}
          value={form.oldPassword}
          onChange={(val) => setForm({ ...form, oldPassword: val.target.value })}
        />
        <Input
          type='password'
          className='w-full'
          design='bordered'
          label={'New Password'}
          name='newPassword'
          placeholder={'************'}
          value={form.newPassword}
          onChange={(val) => {
            if (val.target.value !== form.confirmPassword) {
              setErrors({
                ...errors,
                [val.target.name]: 'New password has to match with Confirm password'
              });
            } else {
              setErrors(defaultError);
            }
            updatePassword(val);
          }}
          error={errors.newPassword ? errors.newPassword : ''}
        />
        <Input
          type='password'
          className='w-full'
          design='bordered'
          label={'Confirm Password'}
          name='confirmPassword'
          placeholder={'************'}
          value={form.confirmPassword}
          onChange={(val) => {
            if (val.target.value !== form.newPassword) {
              setErrors({
                ...errors,
                [val.target.name]: 'New password has to match with Confirm password'
              });
            } else {
              setErrors(defaultError);
            }
            updatePassword(val);
          }}
          error={errors.confirmPassword ? errors.confirmPassword : ''}
        />
      </div>
    </BaseModal>
  );
};

export default ResetPasswordModal;
